import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';

function Body({ children = undefined, className = '', }) {
    const bodyClass = useMemo(() => cns('application__body', className), [className]);
    return (jsx("div", { className: bodyClass, children: children }));
}
Body.displayName = 'Application.Body';

export { Body as default };
